import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { TradingAccountFilterKey } from 'api/Clients/Types/TradingAccount'
import { WelcomeTradingAccountFilterKey } from 'api/Trading-Accounts/Types/WelcomeTradingAccountDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { CountryFilter, CustomDateFilter, MultiCompanySelectFilter } from './common.filter'
import { TradingWelcomeAccountGroupFilter } from './TradingAccountFields/TradingAccountGroupFilter'
import { TradingAccountStatusFilter } from './TradingAccountFields/TradingAccountStatusFilter'

const getTradingAccountWelcomeFilterFields = (): FieldSettings[] => [
  {
    name: WelcomeTradingAccountFilterKey.name,
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: WelcomeTradingAccountFilterKey.accountGroup,
    label: 'Account Group',
    filter: TradingWelcomeAccountGroupFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  // TODO: temporary commented "campaignId" property (backend in progress)
  // {
  //     name: WelcomeTradingAccountFilterKey.accountType,
  //     label: 'Account Type',
  //     filter: TradingAccountTypeFilter,
  //     operators: [
  //          { text: GridFilterOperatorNameEnum.equalOperator, operator: GridFilterOperatorEnum.equalOperator },
  //          { text: GridFilterOperatorNameEnum.notEqOperator, operator: GridFilterOperatorEnum.notEqOperator },
  //     ],
  // },
  {
    name: WelcomeTradingAccountFilterKey.company,
    label: 'Tickmill Company',
    filter: MultiCompanySelectFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: WelcomeTradingAccountFilterKey.status,
    label: 'Status',
    filter: TradingAccountStatusFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: WelcomeTradingAccountFilterKey.country,
    label: 'Country',
    filter: CountryFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TradingAccountFilterKey.createdDate,
    label: 'Date Created',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
]

export { getTradingAccountWelcomeFilterFields }
